import React, { Component } from 'react';
import { Row, Input } from "antd";
import Table5_3 from "./5_3";
// import Table5_4 from "./5_4";

class index extends Component {


    render() {
        return (
            <div>
                <Table5_3 {...this.props} />
                {/* <Table5_4 {...this.props} /> */}
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-3/index.js